import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { X, Check, ArrowRight } from 'lucide-react';

const WhyQubo = () => {
  const { content } = useLanguage();
  const { whyQuboData, ui } = content;

  return (
    <section className="py-20 lg:py-32 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            {whyQuboData.title}
          </h2>
          <p className="text-lg text-gray-400 max-w-3xl mx-auto">
            {whyQuboData.subtitle}
          </p>
        </div>

        {/* Comparison Grid */}
        <div className="grid lg:grid-cols-2 gap-8 relative">
          {/* Before - Traditional */}
          <div className="relative bg-gradient-to-b from-gray-900 to-gray-950 border border-gray-800 rounded-2xl p-8">
            <div className="absolute -top-4 left-8 bg-gray-800 px-4 py-2 rounded-lg">
              <span className="text-gray-400 font-semibold text-sm">{ui.whyQubo.beforeLabel}</span>
            </div>
            
            <h3 className="text-2xl font-bold text-white mb-6 mt-2">
              {whyQuboData.comparison.before.title}
            </h3>
            
            <div className="space-y-4">
              {whyQuboData.comparison.before.items.map((item, index) => (
                <div key={index} className="flex items-start">
                  <div className="w-6 h-6 bg-red-600/10 rounded-full flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                    <X className="text-red-400" size={14} />
                  </div>
                  <p className="text-gray-400 leading-relaxed">{item}</p>
                </div>
              ))}
            </div>

            {/* Decorative element */}
            <div className="absolute bottom-0 right-0 w-32 h-32 bg-red-600/5 rounded-full blur-3xl"></div>
          </div>

          {/* Arrow indicator */}
          <div className="hidden lg:flex absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
            <div className="bg-blue-600 rounded-full p-4 shadow-2xl">
              <ArrowRight className="text-white" size={32} />
            </div>
          </div>

          {/* After - With Qubo */}
          <div className="relative bg-gradient-to-b from-blue-950/30 to-gray-950 border border-blue-900/50 rounded-2xl p-8">
            <div className="absolute -top-4 left-8 bg-blue-600 px-4 py-2 rounded-lg">
              <span className="text-white font-semibold text-sm">{ui.whyQubo.afterLabel}</span>
            </div>
            
            <h3 className="text-2xl font-bold text-white mb-6 mt-2">
              {whyQuboData.comparison.after.title}
            </h3>
            
            <div className="space-y-4">
              {whyQuboData.comparison.after.items.map((item, index) => (
                <div key={index} className="flex items-start">
                  <div className="w-6 h-6 bg-blue-600/20 rounded-full flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                    <Check className="text-blue-400" size={14} />
                  </div>
                  <p className="text-gray-300 leading-relaxed font-medium">{item}</p>
                </div>
              ))}
            </div>

            {/* Decorative element */}
            <div className="absolute bottom-0 right-0 w-32 h-32 bg-blue-600/10 rounded-full blur-3xl"></div>
          </div>
        </div>

        {/* Bottom highlight */}
        <div className="mt-12 p-10 bg-gradient-to-r from-blue-950/30 to-gray-950/30 border border-blue-900/30 rounded-2xl text-center">
          <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
            {ui.whyQubo.bottomTitle}
          </h3>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            {ui.whyQubo.bottomText}
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyQubo;
